<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="80%"
      @close="close"
    >
      <el-form ref="form" label-width="120px" :model="form" :rules="rules">
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="form.title"
            class="fix-width"
            placeholder="请输入标题"
          />
        </el-form-item>
        <el-form-item label="类型" prop="typehood" >
          <el-radio-group v-model="form.typehood" @change="typehoodChange">
            <el-radio :label="1">景点标签</el-radio>
            <el-radio :label="2">门票标签</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="form.typehood === 2">
          <el-form-item label="上级标签">
            <el-select
              v-model="form.parentTagId"
              placeholder="请选择标签"
              class="fix-width"
              clearable
            >
              <el-option
                v-for="item in tagList"
                :key="item.tagId"
                :label="item.title"
                :value="item.tagId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="适用景区">
            <el-select
              v-model="form.spotIdList"
              placeholder="请选择景区"
              class="fix-width"
              multiple
            >
              <el-option
                v-for="item in spotList"
                :key="item.spotId"
                :label="item.title"
                :value="item.spotId"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>
        <el-form-item label="图标" prop="icon">
          <el-upload
            class="avatar-uploader"
            :show-file-list="false"
            :action="QNUploadURL"
            :data="uploadToken"
            :on-success="image_success"
            :on-remove="image_remove"
          >
            <img v-if="form.icon" :src="form.icon" class="avatar large">
            <i v-else class="avatar-uploader-icon el-icon-plus"></i>
          </el-upload>
          <span>建议尺寸：164px * 164px</span>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createTag, updateTag, findTagAll, findSpotAll } from '@/api/ticket'
import { getUploadToken } from '@/api/app'
import { QNUploadURL, QNHost } from '@/config/net.config'
export default {
  name: 'SpotTagEdit',
  emits: ['fetch-data'],
  data() {
    return {
      title: '',
      QNUploadURL,
      QNHost,
      uploadToken:null,
      tagList: [],
      spotList: [],
      form: {
        tagId:'',
        title: '',
        icon: '',
        order: 1,
        typehood: 1,
      },
      rules: {
        title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
        icon: [
          // {
          //   required: true,
          //   validator: (rule, value, callback) => {
          //     if (value.length == 0) {
          //       callback(new Error('请上传图标'))
          //     } else {
          //       callback()
          //     }
          //   },
          // },
        ],
      },
      dialogFormVisible: false
    }
  },
  methods: {
    async showEdit(row) {
      if (row) {
        this.title = '修改标签'
        this.form = Object.assign(this.form, row.basic)
        this.form.tagId = row.tagId
        this.form.title = row.title
        this.form.typehood = row.typehood
      } else {
        this.title = '新增标签'
      }
      this.dialogFormVisible = true
      const token = await getUploadToken({})
      const spots = await findSpotAll({})
      const tags = await findTagAll({})
      this.spotList = spots
      this.tagList = tags
      this.uploadToken = { token: token.token }
    },
    async typehoodChange(typehood) {
      this.form.parentTagId = ''
      this.form.spotIdList = []
    },
    // 图片
    image_remove(file, fileList) {
      this.form.icon = ''
    },
    image_success(res, file) {
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      this.form.icon = `${QNHost}/${res.hash}`
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const tagId = this.form.tagId
          const data = Object.assign({},this.form)
          this.$baseConfirm(
            `你确定要${tagId ? '修改' : '新增'}标签吗`,
            null,
            async () => {
              tagId
                ? await updateTag(data)
                : await createTag(data)
              this.$baseMessage(
                `${tagId ? '修改' : '新增'}标签成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              this.$emit('fetch-data')
              this.close()
            }
          )
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@mixin size($scale: 1, $type: small) {
  @if $type == large {
    width: 343px * $scale;
  } @else {
    width: 167px * $scale;
  }
  height: 167px * $scale;
}
.avatar-uploader {
  .avatar {
    border-radius: 6px;
    transition: all .3s ease-in-out;
    @include size;
  }
}
.avatar-uploader-icon {
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.tags {
  margin-bottom: 5px;
}
.tags + .tags,
.tags + .button-new-tag {
  margin-left: 10px;
}
.button-new-tag {
  // margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.disabled .el-upload--picture-card {
  display: none;
}
.fix-width {
  width: 500px;
}
.mb-10 {
  margin-bottom: 10px;
}
.tips {
  color: #aaaaaa;
  margin-left: 50px;
}
</style>
